<template>
  <span> {{ amount }}<span class="ranch-credit ml-1">€</span> </span>
</template>

<script>
export default {
  props: ["amount"],
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style></style>
